import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagCoat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      d="M13.5 1.688l3.375 1.687-2.813 3.938v9.562c0 .31-.251.563-.562.563h-1.608a2.25 2.25 0 0 1-1.875-1.002L8.813 14.63a2.25 2.25 0 0 1-.375-1.248V9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.875 3.375l.535 11.223a.562.562 0 0 1-.563.59h-2.785"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M11.25.563l2.25 1.125C12.507 6.3 10.633 8.152 8.437 9c0 0 2.813-5.625 2.813-8.438z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.125 3.375L.59 14.598a.562.562 0 0 0 .563.59h2.784"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 1.688L1.125 3.375l2.813 3.938v9.562c0 .31.251.563.562.563h1.608a2.25 2.25 0 0 0 1.875-1.002L9 14.906"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7.808C8.18 6 6.75 2.568 6.75.563L4.5 1.688c.851 3.954 2.351 5.88 4.145 6.884M6.75.563h4.5M10.688 11.531a.281.281 0 1 1 0 .563.281.281 0 0 1 0-.563"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagCoat;
